<div *ngIf="(basket$ | async) && (shippingMethods$ | async)">
  <!-- shipping method selection -->
  <form [formGroup]="shippingForm" class="form-horizontal">
    <formly-form [form]="shippingForm" [fields]="shippingConfig$ | async" [model]="model" />
  </form>
</div>
